<template>
    <div id="turn-tool-button" style="color:white;">
        <div v-on:click="componentClick">
            <img ref='turnToolButtonImage' :src="imageSrc"
                 alt="Turn" :class="current"></div>
    </div>
</template>

<style scoped>
img {
    width: 100%;
    height: 100%;
}

</style>

<script>
import toolMachine from "../button-based-tool-xstate.js";
import BaseTool from "../base-tool";

import turnIcon from "./turn-tool.png";
import turnIconSelected from "./turn-tool-selected.png";
import cabri from "../../app/cabri-app";
import turnToolMachine from "./turn-tool-xstate";

const imgSrc = {
    selected: turnIconSelected,
    turning: turnIconSelected,
    inactive: turnIcon,
};
const base = new BaseTool();

const name = "turn-tool";
export default {
    name: name,
    created () {
        base.init(this, imgSrc);
        base.created();
    },
    data () {
        return base.data(turnToolMachine, name);
    },
    mounted: base.mounted,

    methods: {
        sendToStateEngine (evt) {
            base.sendToStateEngine(evt, base);
        },
        stateChanged (state) {
            console.log("TurnTool Engine state: ", state);
            cabri.highlightingActive = !(state === toolMachine.initialState.value);
        },
        componentClick: (event) => {
            base.ref.sendToStateEngine("ACTIVATE", base);
        },

        handlePointer (pointerInfo) {
            const evt = {mousePos:
                    {x:pointerInfo.event.clientX,
                    y:pointerInfo.event.clientY}};
            let state = base.ref.current;

            switch (pointerInfo.type) {
                case BABYLON.PointerEventTypes.POINTERDOWN:
                    evt.type = "START"
                    break;
                case BABYLON.PointerEventTypes.POINTERMOVE:
                    if(state === "turning")
                        evt.type = "MOVE";
                    break;
                case BABYLON.PointerEventTypes.POINTERUP:
                    evt.type = "DROP";
                    break;
            }
            if(evt.type)
                base.ref.stateEngine.send(evt);

        },
    },
    public: {},
};

</script>